module.exports = __webpack_public_path__ + "static/media/hall-PF.4ef06e40.svg";